module.exports = __webpack_public_path__ + "img/clear-day.983718e2.svg";